import { CircularProgress, Grid } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React, { useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

import { useCustomStore } from '../../../../../hooks';
import { AccessTypes, DotActivityListResponseDTO } from '../../../../../types';
import { DotTabsList } from '../NavTabs/DotTabsList';
import {
  Badge,
  ContentDiv,
  Img,
  Label,
  RecordNotFound,
  useStyle,
  Values,
} from './CardlistStyles';
import ActivityListDialogContent from './DialogContent/DialogContent';

type DotActivityProps = {
  ActivityList?: Array<DotActivityListResponseDTO>;
  getMoreActivityList?: () => void;
  HasMoreResults?: any;
  getMoreLoader?: any;
};

const DotActivityList: React.FC<DotActivityProps> = (
  props: DotActivityProps,
) => {
  const { authStore }: any = useCustomStore();
  const { ActivityList, getMoreActivityList, getMoreLoader, HasMoreResults } =
    props;
  const classes = useStyle();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [notesView, setNotesView] = useState<DotActivityListResponseDTO | null>(
    null,
  );

  let navTabs: any[] = React.useMemo(() => [], []);

  if (authStore.tokens) {
    // if (!authStore.tokens) {
    const role = authStore.getTokenDetail?.accessType || '';
    if (role === AccessTypes.CompanyAdmin) {
      navTabs = DotTabsList;
    } else if (role === AccessTypes.OwnerOperator) {
      navTabs = DotTabsList;
    }
  }

  const getMoreList = () => {
    getMoreActivityList && getMoreActivityList();
  };
  const closeDialogWindow = () => {
    setIsOpen(false);
  };
  return (
    <>
      <Box
        id={'scrollParent'}
        sx={{ minWidth: 275 }}
        style={{
          height: 'calc(100vh - 175px)',
          overflowX: 'unset',
          overflowY: 'auto',
        }}>
        <InfiniteScroll
          dataLength={
            ActivityList && ActivityList.length ? ActivityList.length : 0
          }
          next={getMoreList}
          hasMore={HasMoreResults}
          scrollableTarget={'scrollParent'}
          style={{ overflow: 'unset !important' }}
          loader={
            getMoreLoader && (
              <div style={{ textAlign: 'center', width: '100%' }}>
                <CircularProgress
                  size={30}
                  sx={{ color: '#DEC330', marginTop: 20 }}
                />
              </div>
            )
          }
          endMessage>
          {ActivityList && ActivityList.length ? (
            ActivityList.map((val, index) => (
              <Card
                key={index}
                style={{
                  backgroundColor: '#fff',
                  borderBottom: '1px solid #d8d8d8',
                  borderRadius: 'unset',
                  boxShadow: 'none',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setIsOpen(true);
                  setNotesView((pre) => ({ ...pre, ...val }));
                }}>
                <CardContent>
                  <Grid
                    container
                    spacing={0.5}
                    minHeight={'100%'}
                    width={'100%'}>
                    <Grid item md={1}>
                      <Badge>
                        <Img
                          alt=""
                          src={
                            navTabs
                              .filter((tabs) => tabs.filter)
                              .find((tab) => tab.shortkey === val.category)
                              ?.activeIcon
                          }
                        />
                      </Badge>
                    </Grid>
                    <Grid item md={7} padding={'0px 13px !important'}>
                      <Typography
                        variant="h5"
                        component="span"
                        fontSize={'16px'}
                        fontWeight={500}
                        fontFamily={'FiraSans-Medium'}
                        color={'#241a2e'}>
                        {val.category ? val.category : ''}
                      </Typography>

                      {val.driver ? (
                        <ContentDiv>
                          <Grid container spacing={0.5} minHeight={'100%'}>
                            <Grid item md={6}>
                              <Label> Driver :</Label>
                            </Grid>
                            <Grid item md={6}>
                              <Values> {val?.driver}</Values>
                            </Grid>
                          </Grid>
                        </ContentDiv>
                      ) : (
                        ''
                      )}

                      <ContentDiv>
                        <Grid container spacing={0.5} minHeight={'100%'}>
                          <Grid item md={6}>
                            <Label> Submitted:</Label>
                          </Grid>
                          <Grid item md={6}>
                            <Values>
                              {moment(val.submittedOn).format('MM/DD/YY')}
                            </Values>
                          </Grid>
                        </Grid>
                      </ContentDiv>

                      <ContentDiv>
                        <Grid container spacing={0.5} minHeight={'100%'}>
                          <Grid item md={6}>
                            <Label> Submitted By: </Label>
                          </Grid>
                          <Grid item md={6}>
                            <Values> {val.submittedBy}</Values>
                          </Grid>
                        </Grid>
                      </ContentDiv>
                    </Grid>
                    <Grid item md={4}>
                      <Typography
                        component={'span'}
                        color={'#979598'}
                        fontSize={'14px'}
                        fontFamily={'FiraSans-Medium'}
                        fontStyle={'italic'}
                        fontWeight={500}>
                        Ref #{val.referenceId ? val.referenceId : ''}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            ))
          ) : (
            <RecordNotFound>No data available</RecordNotFound>
          )}
        </InfiniteScroll>
      </Box>
      <ActivityListDialogContent
        {...{ classes, closeDialogWindow, isOpen, notesView }}
      />
    </>
  );
};

export default observer(DotActivityList);
